import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import MDEditor from "@uiw/react-md-editor";
import { ArrowLeft, Save } from "lucide-react";
import { toast } from "react-toastify";
import { getMDTReportsById, updateMDTReportContext } from "../services/mdtReportService";

const ReportEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [value, setValue] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const location = useLocation();


  useEffect(() => {
    if (!id) return;

    const fetchReport = async () => {
      try {
        const report = await getMDTReportsById(id);

        setValue(report?.context?.mdt_report ?? "");
      } catch (err) {
        console.error("Failed to fetch MDT report", err);
        toast.error("Failed to load MDT report");
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [id]);

  const handleSave = async () => {
  if (!id) return;

  if (!value.trim()) {
    toast.warning("MDT report content cannot be empty");
    return;
  }

  try {
    updateMDTReportContext(id, {
      context: {
        mdt_report: value,
      },
    });
    toast.success("MDT report saved successfully");
    navigate(`/reports/${id}`,{
      state: location.state
    });
  } catch (error) {
    console.error("Save failed", error);
  }    
};

  if (loading) {
    return <div className="text-gray-600">Loading report...</div>;
  }

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-100 rounded-lg"
          >
            <ArrowLeft className="h-5 w-5 text-gray-600" />
          </button>

          <h1 className="text-2xl font-bold text-gray-900">
            Edit MDT Report
          </h1>
        </div>

        <button
          onClick={handleSave}
          className="btn-primary flex items-center space-x-2 disabled:opacity-50"
        >
          <Save className="h-4 w-4" /> 
          <h1>Save</h1>
        </button>
      </div>

      {/* Editor */}
      <div className="card" data-color-mode="light">
        <MDEditor
          value={value}
          onChange={(val: any) => setValue(val || "")}
          height={600}
          preview="edit"
        />
      </div>

    </div>
  );
};

export default ReportEdit;

